<template>
  <div class="login-container">
    <el-card class="login-box" style="border:none;">
      <div style="display:flex;flex-direction:row;justify-content:center;align-items:center;">
        <img src="../../assets/images/logo.png" style="width:2rem;height:2rem;margin:0;"/>
        <p style="margin:0 0 0 0.5rem;font-size:1.25rem;color:#FFFFFF;">保卫土豆</p>
      </div>

      <el-form ref="loginForm"
               class="login-form"
               autocomplete="on"
               :model="loginForm"
               :rules="rules">
        <el-form-item prop="username">
          <el-input v-model="loginForm.username"
                    class="login-input"
                    placeholder="请输入账号"
                    :disabled="loginForm.isLogining">
          </el-input>
          <i class="input-user-icon"></i>
        </el-form-item>

        <el-form-item prop="password">
          <el-input v-model="loginForm.password"
                    class="login-input"
                    placeholder="请输入登陆密码"
                    show-password
                    :disabled="loginForm.isLogining"
                    @keyup.enter.native="onSubmit">
          </el-input>
          <i class="input-password-icon"></i>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit" class="login-btn" :loading="loginForm.isLogining">
            {{loginForm.isLogining ? '登录中/logining' : '登录 / Login'}}
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <div style="position:absolute;bottom:1rem;left:50%;transform: translateX(-50%);">
      <a style="color:#FFFFFF;margin-right:8px;" href="https://beian.miit.gov.cn/#/Integrated/index" rel="noreferrer" target="_blank">冀ICP备2024082365号-4</a>

      <img src="../../assets/images/beian.png" style="height:14px;width:12.6px;margin-right:2px;" />
      <a style="color:#FFFFFF;" href="https://beian.mps.gov.cn/#/query/webSearch?code=13065202000647" rel="noreferrer" target="_blank">冀公网安备13065202000647号</a>
    </div>
  </div>
</template>

<script>
import { postRequest } from 'utils/http-service'
import { LOGIN } from '../../constants/url'
import { SESSION_KEY_USER, LOCAL_KEY_CURRENT_LANGUAGE } from '../../constants/StorageKeys'
import md5 from 'js-md5'
import pinyin from 'js-pinyin'
import { LanguageEnum } from 'utils/LanguageEnum'
import fingerprint from 'fingerprintjs2'
import { detectDeviceType } from 'utils/CommonAPIs'

export default {
  name: 'login',
  data () {
    return {
      deviceID: null,
      loginData: null,
      loginForm: {
        username: '',
        password: '',
        isLogining: false
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名!', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码!', trigger: 'blur' }
        ]
      }
    }
  },

  methods: {
    onSubmit () {
      let that = this

      that.$refs.loginForm.validate((valid) => {
        if (!valid) {
          return
        }

        let params = {}
        params.deviceType = detectDeviceType()
        params.deviceID = that.deviceID
        params.production = '管理后台'
        params.username = that.loginForm.username
        params.password = that.loginForm.password
        params.passwordMD5 = md5(that.loginForm.password).toUpperCase()
        that.loginForm.isLogining = true

        postRequest(LOGIN, params)
          .then(res => {
            that.loginForm.isLogining = false
            that.loginData = that.transformData(res.data)

            if (!that.loginData) {
              that.$message({
                showClose: true,
                message: '连接到服务器失败，请稍后重试！'
              })
              console.warn(that.$route.name + ' onSubmit err: 没有登陆信息，登陆失败！')
              return
            }

            if (res.code !== 0 && !res.success) {
              that.$message({
                showClose: true,
                message: '用户名或密码错误！'
              })
              console.error(that.$route.name + ' onSubmit err:' + res.message)
              return
            }

            window.sessionStorage.setItem(SESSION_KEY_USER, JSON.stringify(that.loginData))

            // 如果当前登录的用户不是上次登录的用户或者距离上次登录时间超过7天，则强制刷新页面，否则keep-alive会保留上次登录用的页面
            let lastLoginUserInfo = JSON.parse(window.localStorage.getItem(SESSION_KEY_USER)) || {}
            window.localStorage.setItem(SESSION_KEY_USER, JSON.stringify(Object.assign({ foregroundLoginTimestamp: new Date().getTime() }, that.loginData)))
            let needReload = lastLoginUserInfo.id !== that.loginData.id || (new Date().getTime() - lastLoginUserInfo.foregroundLoginTimestamp) > 7 * 24 * 3600 * 1000

            if (res.data.mustRestPassword) {
              that.$message({ message: '密码强度太低，请重设密码！', showClose: true })
              setTimeout(function () {
                that.$router.push({
                  name: 'setting-password',
                  params: { reload: needReload }
                })
              }, 500)
            } else {
              let lastLanguageText = window.sessionStorage.getItem(LOCAL_KEY_CURRENT_LANGUAGE)
              let currLanguageText = (pinyin.getFullChars(that.loginData.userName) !== that.loginData.userName)
                ? LanguageEnum.CHINESE.text : LanguageEnum.ENGLISH.text
              window.sessionStorage.setItem(LOCAL_KEY_CURRENT_LANGUAGE, currLanguageText)
              if (lastLanguageText !== currLanguageText) {
                needReload = true
              }

              that.$router.push({
                name: 'home',
                params: { reload: needReload }
              })
            }
          })
          .catch(err => {
            that.loginForm.isLogining = false
            console.error(that.$route.name + ' onSubmit err:' + err)
          })
      })
    },

    transformData (resData) {
      if (!resData) {
        resData = {}
      }
      resData.id = resData.id || ''
      resData.userName = resData.name || ''
      resData.token = resData.token || ''
      resData.role = resData.role || ''
      resData.userCompanyID = resData.userCompanyID || ''
      return resData
    },

    // 生成设备指纹哈希值
    _getFingerprint () {
      let that = this
      fingerprint.get((components) => {
        const values = components.map(component => component.value)
        that.deviceID = fingerprint.x64hash128(values.join(''), 31)
      })
    }
  },

  mounted () {
    let that = this

    if (window.requestIdleCallback) {
      requestIdleCallback(() => that._getFingerprint())
    } else {
      setTimeout(() => that._getFingerprint(), 500)
    }
  }
}
</script>

<style lang="less" scoped>
.login-container {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background: url("../../assets/images/login-background.jpg") no-repeat center / cover;
  .login-box {
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 300px;
    height: 280px;
    background: url("../../assets/images/login-form-background.png") no-repeat center / cover;
    img {
      display: block;
      margin-left: 35px;
    }
    .login-form {
      height: 220px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      padding: 0 15px;
      box-sizing: border-box;
      .el-form-item {
        margin-bottom: 0;
        .login-input /deep/ input {
          box-sizing: border-box;
          padding-left: 60px;
          border: 1px solid #666;
        }
        .input-user-icon, .input-password-icon {
          display: block;
          position: absolute;
          top: 2px;
          left: 1px;
          width: 40px;
          height: 37.4px;
          background-color: #eee;
          border-radius: 3px 0 0 3px;
        }
        .input-user-icon {
          background: url('../../assets/images/user-icon.png') no-repeat center;
        }
        .input-password-icon {
          background: url('../../assets/images/password-icon.png') no-repeat center;
        }
        .login-btn {
        width: 100%;
        background-color: rgba(243, 215, 53, 0.6);
        color: black;
        outline: none;
        border: 1px solid #555;
        &:hover {
          background-color: rgba(243, 215, 53, 1);
        }
        &:active {
          background-color: rgb(223, 194, 35)
        }
      }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue